import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../../components/forms/Buttons/Button";
import Input from "../../../components/forms/Input/Input";
import Select from "../../../components/forms/Select/Select";
import CustomDialog from "../../../components/modals/CustomDialog/CustomDialog";

export default function ExamCenterForm({
  isOpen,
  isEdit,
  formData,
  setFormData,
  regions,
  onClose,
  onSubmit,
}) {
  const [t] = useTranslation();

  const handleClose = () => {
    setFormData({ name: "", region: null });
    onClose();
  };

  return (
    <CustomDialog
      isOpen={isOpen}
      headerText={
        isEdit ? t("admin.edit_exam_center") : t("admin.create_exam_center")
      }
      closeModal={handleClose}
    >
      <div className="flex flex-col gap-4">
        <Input
          label={t("admin.exam_center_name")}
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          required
        />
        <Select
          label={t("admin.region")}
          value={formData.region}
          onChange={(opt) =>
            setFormData({ ...formData, region: opt?.value || null })
          }
          options={regions}
          required
          isSearchable
        />

        <div className="flex justify-end gap-2">
          <Button text={t("buttons.cancel")} onClick={handleClose} />
          <Button
            text={isEdit ? t("buttons.update") : t("buttons.create")}
            onClick={onSubmit}
            color="primary"
          />
        </div>
      </div>
    </CustomDialog>
  );
}

